module.exports = __webpack_public_path__ + "static/multi-leader-replication-43b91aad627693e24ee53d8e0ab12f40.png";